import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert-invite',
  templateUrl: './alert-invite.component.html',
  styleUrls: ['./alert-invite.component.scss']
})
export class AlertInviteComponent implements OnInit {

  @Input() companyName: string;

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
  }

  close(param) {
    this.activeModal.close(param);
  }

}
